import React from 'react';
import { MailIcon } from 'lucide-react';
export function RenewalAndProfile() {
  return <div className="w-full" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-2209">
      <div className="max-w-4xl mx-auto px-4 md:px-8 pt-12" data-id="element-2210">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-2211">
          {/* Renewal */}
          <div data-id="element-2212">
            <h2 className="text-2xl font-bold uppercase mb-4" style={{
            fontFamily: 'Oswald, sans-serif',
            color: '#1e3d2f'
          }} data-id="element-2213">
              Membership Renewal
            </h2>
            <div className="space-y-4" data-id="element-2214">
              <p className="text-sm" style={{
              color: '#5a5a5a',
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-2215">
                Members who have let their membership lapse and failed to renew
                within the 15 day grace period will have their membership
                terminated and will need to contact the Membership Manager to be
                reinstated.
              </p>
              <p className="text-sm" style={{
              color: '#5a5a5a',
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-2216">
                If the membership is not renewed within a year of expiration,
                those members must reapply for a new membership, be approved by
                the Board of Directors, AND attend "New Member Orientation"
                prior to being allowed to use any of the shooting ranges again.
              </p>
            </div>
          </div>

          {/* Profile Info */}
          <div data-id="element-2217">
            <h2 className="text-2xl font-bold uppercase mb-4" style={{
            fontFamily: 'Oswald, sans-serif',
            color: '#1e3d2f'
          }} data-id="element-2218">
              Member Profile
            </h2>
            <div className="space-y-4" data-id="element-2219">
              <p className="text-sm" style={{
              color: '#5a5a5a',
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-2220">
                A "Profile" is created within our system for each member at the
                time of application. A member can access and update their own
                individual "Profile" at any time using their email address as
                their "Login ID" and the password they created during the
                application process.
              </p>
              <p className="text-sm" style={{
              color: '#5a5a5a',
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-2221">
                Terminated members will not have access to their profile after
                their "Renewal Grace Period" is over.
              </p>
              <div className="flex items-center gap-2 mt-2" data-id="element-2222">
                <MailIcon size={16} style={{
                color: '#c8a84b'
              }} data-id="element-2223" />
                <a href="mailto:ClubMembershipMgr@fentonlakes.com" className="text-sm font-semibold transition-colors hover:underline" style={{
                color: '#1e3d2f',
                fontFamily: 'Inter, sans-serif'
              }} data-id="element-2224">
                  ClubMembershipMgr@fentonlakes.com
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}